import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import {
  Modal,
  Form,
  Input,
  Button,
  Tabs,
  Radio,
  InputNumber,
  Select,
  Flex,
  Divider,
  Switch,
  Space,
  TimePicker,
  message,
  Col,
  Row,
} from 'antd';
import IntlMessage from '../../components/IntlMessage';
import { useIntl } from 'react-intl';
import operatorsApi from '../../api/operators';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import UploadImage from '../../components/Elements/UploadImage';
import {
  entity_app_params,
  list_app_params,
  operator_params,
  sms_params,
  ticket_params,
} from '../../utils/constant';
import dayjs from 'dayjs';
import opPaymentMethodsApi from '../../api/op-payment-method';
import busOrdersApi from '../../api/bus_orders';

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
const { TextArea } = Input;
export const sms_gateway = ['orange', 'mtarget'];

const SMS_TEST_DATA = ['sms_test_1', 'sms_test_2', 'sms_test_3'];

export default function OperatorsForm(props) {
  // const isMount = useRef(false);
  const { onClose, currentData, open } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const intl = useIntl();
  const [imgs, setImgs] = useState(null);
  const [usersData, setUsersData] = useState([]);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    order_by: 'id',
    order_dir: 'ASC',
    keyword: '',
  });

  const [check, setcheck] = useState(false);

  const [timeSellingStart, setTimeSellingStart] = useState(false);

  const [isShowTime, setIsShowTime] = useState({
    user: false,
    op: false,
    agent: false,
  });
  const place_pass = 'input password';
  const isMounted = useRef(false);

  const parsedMetaData = currentData?.params
    ? JSON.parse(currentData.params)
    : operator_params.reduce((acc, key) => {
        acc[key] = null;
        return acc;
      }, {});

  const initialMetaData = {
    ...parsedMetaData,
    sale_edit_type: parsedMetaData.sale_edit_type ?? '0',
    sale_date_annulation_order: parsedMetaData.sale_date_annulation_order
      ? dayjs(parsedMetaData.sale_date_annulation_order, 'HH:mm')
      : dayjs('00:00', 'HH:mm'), // hoặc null nếu bạn muốn không set mặc định
    sale_limit_order_temps: parsedMetaData.sale_limit_order_temps
      ? dayjs(parsedMetaData.sale_limit_order_temps, 'HH:mm')
      : dayjs('00:00', 'HH:mm'),
  };

  let initialValues = {
    ...currentData,
    user_id: currentData?.userId ?? null,
    hotline: currentData?.hotline ?? '',
    mobile: currentData?.phone ?? '',

    meta_data: initialMetaData,
    sms_data:
      currentData && currentData.sms_params
        ? sms_params.map((key) => ({
            [key]:
              currentData && currentData.sms_params
                ? JSON.parse(currentData.sms_params)[key] || null
                : null,
          }))
        : sms_params &&
          sms_params.map((key) => ({
            [key]: key === 'sms_gateway' ? 'orange' : null,
          })),
    ticket_data:
      currentData && currentData.ticket_params
        ? ticket_params.map((key) => ({
            [key]:
              currentData && currentData.ticket_params
                ? JSON.parse(currentData.ticket_params)[key] || null
                : null,
          }))
        : ticket_params &&
          ticket_params.map((key) => ({
            [key]: null,
          })),
  };
  console.log(initialValues.meta_data.sale_edit_type);
  useEffect(() => {
    form.setFieldsValue({ app_data: null });
    if (currentData?.app_params) {
      const obj = { ...JSON.parse(currentData?.app_params || '{}') };

      const userCustomStt = obj['user_custom_stt'];
      const userCustomSttTo = obj['user_custom_stt_to'];

      const opCustomStt = obj['op_custom_stt'];
      const opCustomSttTo = obj['op_custom_stt_to'];

      const agentCustomStt = obj['agent_custom_stt'];
      const agentCustomSttTo = obj['agent_custom_stt_to'];

      obj['user_custom_stt'] = userCustomStt
        ? dayjs(userCustomStt, 'HH:mm')
        : null;
      obj['user_custom_stt_to'] = userCustomSttTo
        ? dayjs(userCustomSttTo, 'HH:mm')
        : null;

      obj['op_custom_stt'] = opCustomStt ? dayjs(opCustomStt, 'HH:mm') : null;
      obj['op_custom_stt_to'] = opCustomSttTo
        ? dayjs(opCustomSttTo, 'HH:mm')
        : null;

      obj['agent_custom_stt'] = agentCustomStt
        ? dayjs(agentCustomStt, 'HH:mm')
        : null;
      obj['agent_custom_stt_to'] = agentCustomSttTo
        ? dayjs(agentCustomSttTo, 'HH:mm')
        : null;
      if (
        JSON.parse(currentData?.app_params)['user_selling_start'] === 'Custom'
      ) {
        if (userCustomStt !== null) {
          setIsShowTime((prev) => ({ ...prev, user: true }));
        }
      }
      if (
        JSON.parse(currentData?.app_params)['op_selling_start'] === 'Custom'
      ) {
        if (opCustomStt !== null) {
          setIsShowTime((prev) => ({ ...prev, op: true }));
        }
      }
      if (
        JSON.parse(currentData?.app_params)['agent_selling_start'] === 'Custom'
      ) {
        if (agentCustomStt !== null) {
          setIsShowTime((prev) => ({ ...prev, agent: true }));
        }
      }
      console.log('result', obj);
      form.setFieldsValue({ app_data: obj });
    }
  }, [currentData, form]);

  const fetchUserOperator = useCallback(
    async (keyword = '') => {
      if (isMounted) {
        try {
          const newFilter = { ...filter, keyword };
          operatorsApi
            .getAllUser(newFilter)
            .then((res) => {
              setUsersData(
                res.data.map((item, i) => {
                  return {
                    label: `${item?.user?.firstname} ${item?.user?.lastname} (${item?.user?.mobile})`,
                    value: item?.user?.id,
                  };
                })
              );
            })
            .catch((err) => console.log(err));
        } catch (err) {
          console.log(err);
        }
      }
    },
    [filter]
  );

  function normalizeField(field) {
    if (!field) return {};

    try {
      const parsed = JSON.parse(field);

      // Kiểu 1: object bình thường
      if (!Array.isArray(parsed) && typeof parsed === 'object') {
        return parsed;
      }

      // Kiểu 2: array [{ fieldName, value, code }]
      if (Array.isArray(parsed)) {
        return parsed.reduce((acc, item) => {
          if (item.code && item.value) {
            acc[item.code] = item.value;
          }
          return acc;
        }, {});
      }

      return {};
    } catch (e) {
      console.error('Invalid field JSON:', field);
      return {};
    }
  }

  const fetchOperatorMethod = useCallback(async () => {
    if (isMounted) {
      try {
        const newFilter = {
          ...filter,
          filter_name: ['operator_id'],
          filter_value: [currentData?.id],
        };
        opPaymentMethodsApi
          .getAll(newFilter)
          .then((res) => {
            const DATA = res.data;
            if (DATA.length > 0) {
              const newData = DATA.map((d) => ({
                ...d,
                ...(d.field ? normalizeField(d.field) : {}),
              }));

              const mappedData = {
                payment_method: {
                  orangemoney: newData.find(
                    (d) => d.payment_method.method === 'orangemoney'
                  ),
                  wave: newData.find((d) => d.payment_method.method === 'wave'),
                },
              };

              form.setFieldsValue(mappedData);
            }
          })
          .catch((err) => console.log(err));
      } catch (err) {
        console.log(err);
      }
    }
  }, [filter, form, currentData]);

  useEffect(() => {
    isMounted.current = true;

    // fetchUserOperator();
    fetchOperatorMethod();
    return () => {
      isMounted.current = false;
    };
  }, [fetchOperatorMethod, isMounted]);

  const handleSearchUser = (value) => {
    fetchUserOperator(value);
  };

  const handleSubmit = () => {
    setLoading(true);

    form
      .validateFields()
      .then((values) => {
        let data = { ...values };
        console.log('data', data);
        if (values.app_data) {
          if (values.app_data.user_selling_start === 'Any time') {
            delete values.app_data.user_custom_stt;
            delete values.app_data.user_custom_stt_to;
            values.app_data.user_custom_stt = null;
            values.app_data.user_custom_stt_to = null;
          }
          if (values.app_data.op_selling_start === 'Any time') {
            delete values.app_data.op_custom_stt;
            delete values.app_data.op_custom_stt_to;
            values.app_data.op_custom_stt = null;
            values.app_data.op_custom_stt_to = null;
          }

          if (values.app_data.agent_selling_start === 'Any time') {
            delete values.app_data.agent_custom_stt;
            delete values.app_data.agent_custom_stt_to;
            values.app_data.agent_custom_stt = null;
            values.app_data.agent_custom_stt_to = null;
          }

          if (values.app_data.agent_custom_stt_to) {
            values.app_data.agent_custom_stt_to =
              values.app_data.agent_custom_stt_to.format('HH:mm');
          }
          if (values.app_data.agent_custom_stt) {
            values.app_data.agent_custom_stt =
              values.app_data.agent_custom_stt.format('HH:mm');
          }

          if (values.app_data.op_custom_stt_to) {
            values.app_data.op_custom_stt_to =
              values.app_data.op_custom_stt_to.format('HH:mm');
          }
          if (values.app_data.op_custom_stt) {
            values.app_data.op_custom_stt =
              values.app_data.op_custom_stt.format('HH:mm');
          }
          if (values.app_data.user_custom_stt_to) {
            values.app_data.user_custom_stt_to =
              values.app_data.user_custom_stt_to.format('HH:mm');
          }
          if (values.app_data.user_custom_stt) {
            values.app_data.user_custom_stt =
              values.app_data.user_custom_stt.format('HH:mm');
          }
        }
        delete data?.image;
        if (data.mobile) {
          data.phone = data.mobile;
        }
        if (!data?.password) {
          delete data.password;
        }
        // if (!check) {
        //   delete data.password;
        // }
        let combinedObject = { ...data.meta_data };
        let combinedObjectSms = {};
        let combinedObjectApp = { ...data.app_data };
        let combinedObjectTicket = {};

        if (combinedObject.sale_date_annulation_order) {
          combinedObject.sale_date_annulation_order =
            combinedObject.sale_date_annulation_order.format('HH:mm');
        }
        if (combinedObject.sale_limit_order_temps) {
          combinedObject.sale_limit_order_temps =
            combinedObject.sale_limit_order_temps.format('HH:mm');
        }
        // currentData &&
        //   data.meta_data.forEach((item) => {
        //     Object.keys(item).forEach((key) => {
        //       combinedObject[key] = item[key];
        //     });
        //   });

        currentData &&
          data.sms_data.forEach((item) => {
            Object.keys(item).forEach((key) => {
              combinedObjectSms[key] = item[key];
            });
          });

        currentData &&
          data.ticket_data.forEach((item) => {
            Object.keys(item).forEach((key) => {
              combinedObjectTicket[key] = item[key];
            });
          });
        // currentData &&
        //   data.app_data !== null &&
        //   data.app_data.forEach((item) => {
        //     Object.keys(item).forEach((key) => {
        //       combinedObjectApp[key] = item[key];
        //     });
        //   });

        if (
          combinedObject ||
          combinedObjectSms ||
          combinedObjectApp ||
          combinedObjectTicket
        ) {
          data = {
            ...data,
            params: JSON.stringify(combinedObject),
            sms_params: JSON.stringify(combinedObjectSms),
            app_params: JSON.stringify(combinedObjectApp),
            ticket_params: JSON.stringify(combinedObjectTicket),
          };
        }

        if (data.payment_method) {
          data.payment_method = JSON.stringify(data.payment_method);
        }
        console.log('data1', data);
        const payload = new FormData();
        Object.keys(data).forEach((key) => {
          let value = data[key];

          // Nếu là boolean thì convert thành 1 hoặc 0
          if (typeof value === 'boolean') {
            value = value ? 1 : 0;
          }

          payload.append(key, value);
        });
        if (imgs) {
          payload.append('image', imgs);
        }
        // if (values.meta_data) {
        //   payload.delete("meta_data");
        //   const arrToObj = Object.assign({}, ...values.meta_data);
        //   payload.append("meta_data", JSON.stringify(arrToObj));
        // }

        if (values.meta_data) {
          payload.delete('meta_data');
        }

        if (values.sms_data) {
          payload.delete('sms_data');
        }

        if (values.ticket_data) {
          payload.delete('ticket_data');
        }

        if (values.sms_data) {
          payload.delete('app_data');
        }

        console.log('payload', payload);
        if (currentData) {
          operatorsApi
            .update(currentData.id, payload)
            .then(() => {
              setLoading(false);
              message.success('Update operator successfully!');
              handleCancel();
              props.onReload();
            })
            .catch((error) => {
              console.error(error);
              Modal.error({
                title: error.data.message,
                okText: intl.formatMessage({ id: 'global.close' }),
              });
              setLoading(false);
            });
        } else {
          operatorsApi
            .create(payload)
            .then(() => {
              setLoading(false);
              message.success('Create operator successfully!');
              handleCancel();
              props.onReload();
            })
            .catch((error) => {
              console.error(error);
              Modal.error({
                title: error.data.message,
                okText: intl.formatMessage({ id: 'global.close' }),
              });
              setLoading(false);
            });
        }
      })
      .catch(() => setLoading(false));
  };

  const onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
  };

  const handleCancel = () => {
    //form.resetFields();
    onClose();
  };

  const onChangeImage = (v, f) => {
    setImgs(f);
  };

  const onChangeTime = (time, timeString) => {
    setTimeSellingStart(timeString);
  };

  const onChangeRadioSelling = (e) => {
    const { value, name } = e.target;
    if (name === 'user_selling') {
      setIsShowTime((prev) => ({ ...prev, user: value === 'Custom' }));
    }
    if (name === 'op_selling') {
      setIsShowTime((prev) => ({ ...prev, op: value === 'Custom' }));
    }

    if (name === 'agent_selling') {
      setIsShowTime((prev) => ({ ...prev, agent: value === 'Custom' }));
    }
  };

  const [formTest] = Form.useForm();

  const handleSend = async (fieldName, index) => {
    try {
      const values = await formTest.validateFields();
      const row = values.items[fieldName][index]; // lấy row tương ứng

      if (!row?.order || !row?.phone) {
        Modal.error({
          title:
            'Veuillez saisir le numéro de commande et le numéro de téléphone',
          okText: intl.formatMessage({ id: 'global.close' }),
        });
        return;
      }

      const res = await busOrdersApi.sendSmsTicketTest({
        order_no: row?.order,
        phone: row?.phone,
      });

      if (res) {
        message.success({
          content: intl.formatMessage({ id: 'global.send_success' }),
        });
      }
    } catch (error) {
      console.error(error);
      Modal.error({
        title: error.data.message,
        okText: intl.formatMessage({ id: 'global.send_failed' }),
      });
    }
  };

  const fileList = useMemo(
    () =>
      currentData && currentData.image
        ? [
            {
              uid: '1',
              name: 'image.png',
              status: 'done ',
              url: currentData.image,
            },
          ]
        : [],
    [currentData]
  );
  console.log(
    'getFieldValue',
    form.getFieldValue(['meta_data', 'sale_edit_type'])
  );
  const tabItems = [
    {
      key: '1',
      label: <IntlMessage id="global.operators" />,
      children: (
        <>
          <Form.Item
            label={<IntlMessage id="global.title" />}
            name="title"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}>
            <Input placeholder="Operator name" />
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.short_name" />}
            name="short_name"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}>
            <Input placeholder="Short name" />
          </Form.Item>

          {/* <Form.Item
            label={<IntlMessage id="global.description" />}
            name="description"
            valuePropName="data"
            getValueFromEvent={(event, editor) => {
              const data = editor.getData();
              // console.log({ event, editor, data });
              return data;
            }}
          >
            <CKEditor editor={ClassicEditor} />
          </Form.Item> */}

          <Form.Item
            label={<IntlMessage id="global.lastname" />}
            name="lastname"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}>
            <Input />
          </Form.Item>

          <Form.Item
            label={<IntlMessage id="global.firstname" />}
            name="firstname"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}>
            <Input />
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.email" />}
            name="email"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
              {
                type: 'email',
                message: <IntlMessage id="validate.is_not_email" />,
              },
            ]}>
            <Input />
          </Form.Item>

          <Form.Item
            label={<IntlMessage id="global.phone" />}
            name="mobile"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}>
            <Input placeholder="Phone number" />
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.hotline" />}
            name="hotline"
            rules={[
              {
                required: false,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}>
            <Input placeholder="Hotline" />
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.logo" />}
            name="image"
            rules={[
              {
                required: false,
              },
            ]}>
            <UploadImage onChangeData={onChangeImage} initList={fileList} />
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.tax" />}
            name="tax"
            rules={[
              {
                required: false,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}>
            <Input placeholder="Tax" />
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.password" />}
            name="password">
            <Input.Password placeholder={place_pass} />
          </Form.Item>
        </>
      ),
    },
    {
      label: <IntlMessage id="global.setting" />,
      key: '2',
      forceRender: true,
      children: (
        <>
          {/* -------- GENERAL -------- */}
          <h3>GENERAL</h3>

          {/* Actif/Désactivé */}
          <Form.Item name={'status'} label="Actif/Désactivé">
            <Switch
              unCheckedChildren={<IntlMessage id="global.disabled" />}
              checkedChildren={<IntlMessage id="global.enabled" />}
            />
          </Form.Item>

          {/* Commission % */}
          <Form.Item name={'tax'} label="Commission">
            <InputNumber min={0} addonAfter="%" />
          </Form.Item>
          <Form.List name="meta_data">
            {() => (
              <>
                {/* Devise */}
                <Form.Item name={['sale_currency_devise']} label="Devise">
                  <Select placeholder="Sélectionner une devise">
                    <Select.Option value="XOF">
                      XOF - Franc CFA (Afrique de l’Ouest)
                    </Select.Option>
                    <Select.Option value="EUR">EUR - Euro</Select.Option>
                    <Select.Option value="USD">USD - Dollar US</Select.Option>
                    <Select.Option value="GBP">
                      GBP - Livre sterling
                    </Select.Option>
                    <Select.Option value="JPY">
                      JPY - Yen japonais
                    </Select.Option>
                    <Select.Option value="CHF">
                      CHF - Franc suisse
                    </Select.Option>
                    <Select.Option value="CAD">
                      CAD - Dollar canadien
                    </Select.Option>
                    <Select.Option value="AUD">
                      AUD - Dollar australien
                    </Select.Option>
                    <Select.Option value="CNY">
                      CNY - Yuan chinois
                    </Select.Option>
                    <Select.Option value="INR">
                      INR - Roupie indienne
                    </Select.Option>
                    <Select.Option value="BRL">
                      BRL - Réal brésilien
                    </Select.Option>
                    <Select.Option value="ZAR">
                      ZAR - Rand sud-africain
                    </Select.Option>
                  </Select>
                </Form.Item>

                {/* Symbole */}
                <Form.Item name={['sale_currency_symbol']} label="Symbole">
                  <Input />
                </Form.Item>

                {/* Affichage devise */}
                <Form.Item
                  noStyle
                  shouldUpdate={(prev, curr) =>
                    prev.meta_data?.sale_currency_symbol !==
                    curr.meta_data?.sale_currency_symbol
                  }>
                  {({ getFieldValue }) => {
                    const devise =
                      getFieldValue(['meta_data', 'sale_currency_symbol']) ||
                      'XXX';
                    return (
                      <Form.Item
                        name={['sale_currency_display']}
                        label="Affichage devise">
                        <Select placeholder="Sélectionner une option">
                          <Select.Option value={`100 ${devise}`}>
                            100 {devise}
                          </Select.Option>
                          <Select.Option value={`${devise} 100`}>
                            {devise} 100
                          </Select.Option>
                        </Select>
                      </Form.Item>
                    );
                  }}
                </Form.Item>

                {/* Décimal */}
                <Form.Item name={['sale_currency_decimal']} label="Décimal">
                  <InputNumber min={0} style={{ width: '100%' }} />
                </Form.Item>

                {/* -------- RESERVATION -------- */}
                <h3 style={{ marginTop: 16 }}>RESERVATION</h3>

                {/* Délai annulation réservation */}
                <Form.Item
                  name={['sale_date_annulation_order']}
                  label="Délai annulation réservation">
                  <TimePicker
                    format="HH:mm"
                    placeholder="Sélectionner l'heure"
                    style={{ width: '100%' }}
                    // nếu muốn set mặc định là 00:00
                    defaultValue={initialMetaData.sale_date_annulation_order}
                  />
                </Form.Item>
                <Form.Item label="Délai limite réservation">
                  <Flex gap={16} align="center">
                    {/* Radio Group */}
                    <Form.Item
                      name={['sale_limit_order_type']}
                      style={{ marginBottom: 0 }}>
                      <Radio.Group>
                        <Radio value="0">illimité</Radio>
                        <Radio value="1">Limiter</Radio>
                      </Radio.Group>
                    </Form.Item>

                    {/* InputNumber */}
                    <Form.Item noStyle shouldUpdate={(prev, curr) => true}>
                      {({ getFieldValue }) => {
                        return getFieldValue([
                          'meta_data',
                          'sale_limit_order_type',
                        ]) !== '0' ? (
                          <Form.Item
                            name={['sale_limit_order_date']}
                            style={{ marginBottom: 0 }}>
                            <InputNumber min={0} addonAfter="jours" />
                          </Form.Item>
                        ) : null;
                      }}
                    </Form.Item>
                  </Flex>
                </Form.Item>

                {/* Délai limite réservation */}
                <Form.Item
                  name={['sale_limit_order_temps']}
                  label="Temps limite réservation">
                  <TimePicker
                    format="HH:mm"
                    placeholder="Sélectionner l'heure"
                    style={{ width: '100%' }}
                    // nếu muốn set mặc định là 00:00
                    defaultValue={initialMetaData.sale_limit_order_temps}
                  />
                </Form.Item>

                {/* -------- REPORT -------- */}
                <h3 style={{ marginTop: 16 }}>REPORT</h3>

                {/* Activer modification */}
                <Form.Item name={['sale_edit_enable']} label="Actif/Désactivé">
                  <Switch
                    unCheckedChildren={<IntlMessage id="global.disabled" />}
                    checkedChildren={<IntlMessage id="global.enabled" />}
                  />
                </Form.Item>
                <Form.Item label="Voyage">
                  <Flex gap={16} align="center">
                    {/* Radio Group */}
                    <Form.Item
                      name={['sale_edit_type']}
                      style={{ marginBottom: 0 }}>
                      <Radio.Group>
                        <Radio value="0">Avant</Radio>
                        <Radio value="1">Après</Radio>
                      </Radio.Group>
                    </Form.Item>

                    <Form.Item
                      name={['sale_date_upto']}
                      style={{ marginBottom: 0 }}>
                      <InputNumber min={0} addonAfter="jours" />
                    </Form.Item>
                  </Flex>
                </Form.Item>

                {/* Nombre de changements */}
                <Form.Item
                  name={['sale_edit_change_limit']}
                  label="Nombre de changements">
                  <InputNumber min={0} style={{ width: '100%' }} />
                </Form.Item>
              </>
            )}
          </Form.List>
        </>
      ),
    },
    {
      label: <IntlMessage id="global.payment" />,
      key: '3',
      forceRender: true,
      children: (
        <>
          <Form.List name="payment_method">
            {() => (
              <>
                {/* -------- OM -------- */}
                <h3 style={{ marginTop: 16 }}>ORANGE MONEY</h3>
                <Form.List name="orangemoney">
                  {() => (
                    <>
                      <Form.Item
                        name={'status'}
                        label=<IntlMessage id="global.enable_disable" />>
                        <Switch
                          unCheckedChildren={
                            <IntlMessage id="global.disabled" />
                          }
                          checkedChildren={<IntlMessage id="global.enabled" />}
                        />
                      </Form.Item>
                      <Form.Item
                        name={['notify_url']}
                        label=<IntlMessage id="global.notify_url" />>
                        <Input />
                      </Form.Item>
                      <Form.Item
                        name={['identifiant']}
                        label=<IntlMessage id="global.identifiant" />>
                        <Input />
                      </Form.Item>
                      <Form.Item
                        name={['site']}
                        label=<IntlMessage id="global.site" />>
                        <Input />
                      </Form.Item>
                      <Form.Item
                        name={['secret_key']}
                        label=<IntlMessage id="global.secret_key" />>
                        <Input />
                      </Form.Item>
                      <Form.Item
                        name={['error_url']}
                        label=<IntlMessage id="global.error_url" />>
                        <Input />
                      </Form.Item>
                      <Form.Item
                        name={['success_url']}
                        label=<IntlMessage id="global.success_url" />>
                        <Input />
                      </Form.Item>
                      <Form.Item
                        name={['client_id']}
                        label=<IntlMessage id="global.client_id" />>
                        <Input />
                      </Form.Item>
                      <Form.Item
                        name={['client_secret']}
                        label=<IntlMessage id="global.client_secret" />>
                        <Input />
                      </Form.Item>
                      <Form.Item
                        name={['code']}
                        label=<IntlMessage id="global.code" />>
                        <Input />
                      </Form.Item>
                      <Form.Item
                        name={['callback_url']}
                        label=<IntlMessage id="global.callback_url" />>
                        <Input />
                      </Form.Item>
                      <Form.Item
                        name={['wave_template_sms']}
                        label=<IntlMessage id="global.template_sms" />>
                        <TextArea rows={4} />
                      </Form.Item>
                      <Flex style={{ width: '100%' }} gap={16}>
                        <div
                          style={{
                            flex: 1,
                          }}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'start',
                              gap: '10px',
                            }}>
                            <Form.Item
                              name={['is_on_userapp']}
                              style={{ width: '100px' }}
                              labelCol={{ span: 0 }}
                              wrapperCol={{ span: 24 }}>
                              <Switch
                                unCheckedChildren={'User App'}
                                checkedChildren={'User App'}
                                style={{ width: '100%' }}
                              />
                            </Form.Item>
                            <Form.Item
                              name={['is_on_sms_userapp']}
                              labelCol={{ span: 0 }}
                              wrapperCol={{ span: 24 }}>
                              <Switch
                                unCheckedChildren={'SMS OFF'}
                                checkedChildren={'SMS ON'}
                                style={{ width: '100%' }}
                              />
                            </Form.Item>
                            <Form.Item
                              name={['suffix_userapp']}
                              style={{ width: '100px' }}
                              labelCol={{ span: 0 }}
                              wrapperCol={{ span: 24 }}>
                              <Input
                                style={{ width: '100%' }}
                                placeholder="-suffix"
                              />
                            </Form.Item>
                          </div>
                        </div>

                        <div
                          style={{
                            flex: 1,
                            display: 'flex',
                            justifyContent: 'start',
                            alignItems: 'start',
                            gap: '10px',
                          }}>
                          <Form.Item
                            name={['is_on_operatorapp']}
                            style={{ width: '100px' }}
                            labelCol={{ span: 0 }}
                            wrapperCol={{ span: 24 }}>
                            <Switch
                              unCheckedChildren={'Operator App'}
                              checkedChildren={'Operator App'}
                              style={{ width: '100%' }}
                            />
                          </Form.Item>
                          <Form.Item
                            name={['is_on_sms_operatorapp']}
                            style={{ width: '100px' }}
                            labelCol={{ span: 0 }}
                            wrapperCol={{ span: 24 }}>
                            <Switch
                              unCheckedChildren={'SMS OFF'}
                              checkedChildren={'SMS ON'}
                              style={{ width: '100%' }}
                            />
                          </Form.Item>
                          <Form.Item
                            name={['suffix_operatorapp']}
                            style={{ width: '100px' }}
                            labelCol={{ span: 0 }}
                            wrapperCol={{ span: 24 }}>
                            <Input
                              style={{ width: '100%' }}
                              placeholder="-suffix"
                            />
                          </Form.Item>
                        </div>

                        <div
                          style={{
                            flex: 1,
                            display: 'flex',
                            justifyContent: 'start',
                            gap: '10px',
                          }}>
                          <Form.Item
                            name={['is_on_agentapp']}
                            style={{ width: '100px' }}
                            labelCol={{ span: 0 }}
                            wrapperCol={{ span: 24 }}>
                            <Switch
                              unCheckedChildren={'Agent App'}
                              checkedChildren={'Agent App'}
                              style={{ width: '100%' }}
                            />
                          </Form.Item>
                          <Form.Item
                            name={['is_on_sms_agentapp']}
                            style={{ width: '100px' }}
                            labelCol={{ span: 0 }}
                            wrapperCol={{ span: 24 }}>
                            <Switch
                              unCheckedChildren={'SMS OFF'}
                              checkedChildren={'SMS ON'}
                              style={{ width: '100%' }}
                            />
                          </Form.Item>
                          <Form.Item
                            name={['suffix_agentapp']}
                            style={{ width: '100px' }}
                            labelCol={{ span: 0 }}
                            wrapperCol={{ span: 24 }}>
                            <Input
                              style={{ width: '100%' }}
                              placeholder="-suffix"
                            />
                          </Form.Item>
                        </div>
                      </Flex>
                    </>
                  )}
                </Form.List>

                {/* -------- WAVE -------- */}
                <h3 style={{ marginTop: 16 }}>WAVE</h3>
                <Form.List name="wave">
                  {() => (
                    <>
                      <Form.Item
                        name={'status'}
                        label=<IntlMessage id="global.enable_disable" />>
                        <Switch
                          unCheckedChildren={
                            <IntlMessage id="global.disabled" />
                          }
                          checkedChildren={<IntlMessage id="global.enabled" />}
                        />
                      </Form.Item>
                      <Form.Item
                        name={['notify_url']}
                        label=<IntlMessage id="global.notify_url" />>
                        <Input />
                      </Form.Item>
                      <Form.Item
                        name={['error_url']}
                        label=<IntlMessage id="global.error_url" />>
                        <Input />
                      </Form.Item>
                      <Form.Item
                        name={['success_url']}
                        label=<IntlMessage id="global.success_url" />>
                        <Input />
                      </Form.Item>
                      <Form.Item
                        name={['secret_key']}
                        label=<IntlMessage id="global.secret_key" />>
                        <TextArea rows={2} />
                      </Form.Item>
                      <Form.Item
                        name={['wave_template_sms']}
                        label=<IntlMessage id="global.template_sms" />>
                        <TextArea rows={4} />
                      </Form.Item>
                      <Flex style={{ width: '100%' }} gap={16}>
                        <div
                          style={{
                            flex: 1,
                          }}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'start',
                              gap: '10px',
                            }}>
                            <Form.Item
                              name={['is_on_userapp']}
                              style={{ width: '100px' }}
                              labelCol={{ span: 0 }}
                              wrapperCol={{ span: 24 }}>
                              <Switch
                                unCheckedChildren={'User App'}
                                checkedChildren={'User App'}
                                style={{ width: '100%' }}
                              />
                            </Form.Item>
                            <Form.Item
                              name={['is_on_sms_userapp']}
                              labelCol={{ span: 0 }}
                              wrapperCol={{ span: 24 }}>
                              <Switch
                                unCheckedChildren={'SMS OFF'}
                                checkedChildren={'SMS ON'}
                                style={{ width: '100%' }}
                              />
                            </Form.Item>
                            <Form.Item
                              name={['suffix_userapp']}
                              style={{ width: '100px' }}
                              labelCol={{ span: 0 }}
                              wrapperCol={{ span: 24 }}>
                              <Input
                                style={{ width: '100%' }}
                                placeholder="-suffix"
                              />
                            </Form.Item>
                          </div>
                        </div>

                        <div
                          style={{
                            flex: 1,
                            display: 'flex',
                            justifyContent: 'start',
                            alignItems: 'start',
                            gap: '10px',
                          }}>
                          <Form.Item
                            name={['is_on_operatorapp']}
                            style={{ width: '100px' }}
                            labelCol={{ span: 0 }}
                            wrapperCol={{ span: 24 }}>
                            <Switch
                              unCheckedChildren={'Operator App'}
                              checkedChildren={'Operator App'}
                              style={{ width: '100%' }}
                            />
                          </Form.Item>
                          <Form.Item
                            name={['is_on_sms_operatorapp']}
                            style={{ width: '100px' }}
                            labelCol={{ span: 0 }}
                            wrapperCol={{ span: 24 }}>
                            <Switch
                              unCheckedChildren={'SMS OFF'}
                              checkedChildren={'SMS ON'}
                              style={{ width: '100%' }}
                            />
                          </Form.Item>
                          <Form.Item
                            name={['suffix_operatorapp']}
                            style={{ width: '100px' }}
                            labelCol={{ span: 0 }}
                            wrapperCol={{ span: 24 }}>
                            <Input
                              style={{ width: '100%' }}
                              placeholder="-suffix"
                            />
                          </Form.Item>
                        </div>

                        <div
                          style={{
                            flex: 1,
                            display: 'flex',
                            justifyContent: 'start',
                            gap: '10px',
                          }}>
                          <Form.Item
                            name={['is_on_agentapp']}
                            style={{ width: '100px' }}
                            labelCol={{ span: 0 }}
                            wrapperCol={{ span: 24 }}>
                            <Switch
                              unCheckedChildren={'Agent App'}
                              checkedChildren={'Agent App'}
                              style={{ width: '100%' }}
                            />
                          </Form.Item>
                          <Form.Item
                            name={['is_on_sms_agentapp']}
                            style={{ width: '100px' }}
                            labelCol={{ span: 0 }}
                            wrapperCol={{ span: 24 }}>
                            <Switch
                              unCheckedChildren={'SMS OFF'}
                              checkedChildren={'SMS ON'}
                              style={{ width: '100%' }}
                            />
                          </Form.Item>
                          <Form.Item
                            name={['suffix_agentapp']}
                            style={{ width: '100px' }}
                            labelCol={{ span: 0 }}
                            wrapperCol={{ span: 24 }}>
                            <Input
                              style={{ width: '100%' }}
                              placeholder="-suffix"
                            />
                          </Form.Item>
                        </div>
                      </Flex>
                    </>
                  )}
                </Form.List>
              </>
            )}
          </Form.List>
        </>
      ),
    },
    {
      label: <IntlMessage id="global.sms_settings" />,
      key: '4',
      forceRender: true,
      children: (
        <>
          <Form.List name="sms_data">
            {(fields, { add }) => {
              return (
                <>
                  {fields.map((field, index) => {
                    const fieldName = sms_params[index];
                    if (fieldName === 'sender_id') {
                      return (
                        <Form.Item
                          label={<IntlMessage id={`global.${fieldName}`} />}
                          labelCol={{ span: 4 }}
                          name={[index, fieldName]}
                          key={field.key}>
                          <Input style={{ width: 500 }} />
                        </Form.Item>
                      );
                    } else if (fieldName === 'sms_gateway') {
                      return (
                        <Form.Item
                          label={<IntlMessage id={`global.${fieldName}`} />}
                          labelCol={{ span: 4 }}
                          name={[index, fieldName]}>
                          <Select
                            style={{ width: 500 }}
                            showSearch
                            // onChange={onChangePaymentMethod}
                            filterOption={false}
                            options={sms_gateway.map((item, i) => {
                              return {
                                label: item.toLocaleUpperCase() + ' SMS',
                                value: item,
                              };
                            })}
                          />
                        </Form.Item>
                      );
                    } else {
                      return (
                        <Row gutter={0} align="top">
                          {/* Cột bên trái: Form */}
                          <Col flex={1}>
                            <Form.Item
                              label={<IntlMessage id={`global.${fieldName}`} />}
                              labelCol={{ span: 6 }}
                              name={[index, fieldName]}
                              key={field.key}
                              style={{ flex: 'none' }} // giữ nguyên kích thước
                            >
                              <Input.TextArea
                                autoSize={{ minRows: 6 }}
                                style={{ width: 520 }}
                              />
                            </Form.Item>
                          </Col>

                          {/* Cột bên phải: Text note */}
                          <Col span={8}>
                            <Form
                              form={formTest}
                              style={{ width: '100%' }}
                              initialValues={{
                                items: {
                                  [fieldName]: {
                                    phone: '',
                                    order: '',
                                  },
                                },
                              }}>
                              <Flex vertical gap={8}>
                                {SMS_TEST_DATA.map((_, i) => (
                                  <Flex
                                    gap={8}
                                    align="start"
                                    key={`${fieldName}_${i}`}>
                                    <Form.Item
                                      name={['items', fieldName, i, 'phone']}>
                                      <Input
                                        placeholder={'Phone Number'}
                                        style={{ width: 150 }}
                                      />
                                    </Form.Item>
                                    <Form.Item
                                      name={['items', fieldName, i, 'order']}>
                                      <Input
                                        placeholder="Order Reference"
                                        style={{ width: 150 }}
                                      />
                                    </Form.Item>
                                    <Button
                                      type="primary"
                                      onClick={() => handleSend(fieldName, i)}>
                                      Send
                                    </Button>
                                  </Flex>
                                ))}
                              </Flex>
                            </Form>
                          </Col>
                        </Row>
                      );
                    }
                  })}
                  <Flex vertical gap={8}>
                    <Row gutter={[16, 8]}>
                      <Col span={4}>
                        <div strong>Liste des variables:</div>
                      </Col>
                      <Col span={6}>
                        <div>{`{pass_firstname}: Prénom du passager`}</div>
                        <div>{`{Ref}: Référence de la réservation`}</div>
                        <div>{`{from}: Départ`}</div>
                        <div>{`{travel_date}: Date de voyage`}</div>
                        <div>{`{seat}: Numéro de siège`}</div>
                      </Col>
                      <Col span={6}>
                        <div>{`{pass_lastname}: Nom du passager`}</div>
                        <div>{`{route}: Trajet`}</div>
                        <div>{`{to}: Destination`}</div>
                        <div>{`{travel_time}: Heure de départ`}</div>
                        <div>{`{price}: Prix`}</div>
                      </Col>
                      <Col span={6}>
                        <div>{`{trip_code}: Code de la route`}</div>
                        <div>{`{link_me}: Lien vers détails du voyage`}</div>
                      </Col>
                    </Row>
                  </Flex>
                </>
              );
            }}
          </Form.List>
        </>
      ),
    },
    {
      label: <IntlMessage id="global.ticket" />,
      key: '5',
      forceRender: true,
      children: (
        <>
          <Form.List name="ticket_data">
            {(fields, { add }) => {
              return (
                <>
                  {fields.map((field, index) => {
                    const fieldName = ticket_params[index];
                    if (fieldName === 'code_type') {
                      return (
                        <Form.Item
                          label={<IntlMessage id={`global.${fieldName}`} />}
                          name={[index, fieldName]}>
                          <Radio.Group>
                            <Radio value={'qr_code'}>
                              <IntlMessage id="global.qr_code" />
                            </Radio>
                            <Radio value={'bar_code'}>
                              <IntlMessage id="global.bar_code" />
                            </Radio>
                          </Radio.Group>
                        </Form.Item>
                      );
                    } else {
                      return (
                        <Row gutter={0} align="top">
                          {/* Cột bên trái: Form */}
                          <Col flex={1}>
                            <Form.Item
                              label={<IntlMessage id={`global.${fieldName}`} />}
                              labelCol={{ span: 6 }}
                              name={[index, fieldName]}
                              key={field.key}>
                              <Input.TextArea
                                autoSize={{ minRows: 6 }}
                                style={{ width: 500 }}
                              />
                            </Form.Item>
                          </Col>

                          {/* Cột bên phải: Text note */}
                          <Col span={8}>
                            <div
                              strong
                              style={{
                                textAlign: 'center',
                                fontWeight: 'bold',
                              }}>
                              Liste des variables:
                            </div>

                            <div>{`{pass_name}: Nom du passager`}</div>
                            <div>{`{booking_number}: Référence de la réservation`}</div>
                            <div>{`{departure}: Départ`}</div>
                            <div>{`{destination}: Arrival`}</div>
                            <div>{`{trip_date}: Date de voyage`}</div>
                            <div>{`{departure_time}: Heure de départ`}</div>
                            <div>{`{seat_number}: Numéro de siège`}</div>
                            <div>{`{ticket_price}: Prix`}</div>
                            <div>{`{payment_method}: mode de paiement`}</div>
                            <div>{`{trip_code}: Code of the trip`}</div>
                          </Col>
                        </Row>
                      );
                    }
                  })}
                </>
              );
            }}
          </Form.List>
        </>
      ),
    },
    {
      label: <IntlMessage id="global.app_settings" />,
      key: '6',
      forceRender: true,
      children: (
        <>
          <Form.List name="app_data">
            {(fields, { add }) => {
              return (
                <>
                  {entity_app_params.map((item, index) => {
                    return (
                      <>
                        <Divider orientation="left">{item.name}</Divider>
                        <Form.Item
                          label={<IntlMessage id="global.app_listing" />}
                          name={[`${item.label}_app_listing`]}
                          style={{ marginTop: 20 }}>
                          <Input />
                        </Form.Item>
                        <Form.Item
                          label={<IntlMessage id="global.app_status" />}
                          name={[`${item.label}_app_status`]}
                          style={{ marginTop: 20 }}>
                          <Switch
                            unCheckedChildren={
                              <IntlMessage id="global.disabled" />
                            }
                            checkedChildren={
                              <IntlMessage id="global.enabled" />
                            }
                          />
                        </Form.Item>
                        <Form.Item
                          label={<IntlMessage id="global.booking" />}
                          name={[`${item.label}_app_booking`]}
                          style={{ marginTop: 20 }}>
                          <Switch
                            unCheckedChildren={
                              <IntlMessage id="global.disabled" />
                            }
                            checkedChildren={
                              <IntlMessage id="global.enabled" />
                            }
                          />
                        </Form.Item>
                        <Form.Item
                          label={<IntlMessage id="global.booking_message" />}
                          name={[`${item.label}_app_booking_message`]}
                          style={{ marginTop: 20 }}>
                          <Input.TextArea autoSize={{ minRows: 4 }} />
                        </Form.Item>
                        <Form.Item
                          label={<IntlMessage id="global.selling_start" />}
                          name={[`${item.label}_selling_start`]}
                          style={{ marginTop: 20 }}>
                          <Radio.Group
                            name={`${item.label}_selling`}
                            onChange={onChangeRadioSelling}>
                            <Flex>
                              <Space direction="vertical">
                                <Radio value={'Any time'}>
                                  <IntlMessage id="global.any_time" />
                                </Radio>
                                <Radio value={`Custom`}>
                                  <IntlMessage id="global.custom" />
                                </Radio>
                              </Space>
                              {isShowTime[item.label] && (
                                <>
                                  <Form.Item
                                    name={[`${item.label}_custom_stt`]}
                                    style={{ marginTop: 20 }}
                                    labelCol={0}>
                                    <TimePicker
                                      onChange={onChangeTime}
                                      showSecond={false}
                                      showMillisecond={false}
                                      defaultValue={null}
                                      style={{ marginLeft: 24 }}
                                    />
                                  </Form.Item>
                                  <Form.Item
                                    name={[`${item.label}_custom_stt_to`]}
                                    style={{ marginTop: 20 }}
                                    labelCol={0}>
                                    <TimePicker
                                      onChange={onChangeTime}
                                      showSecond={false}
                                      showMillisecond={false}
                                      defaultValue={null}
                                      style={{ marginLeft: 24 }}
                                    />
                                  </Form.Item>
                                </>
                              )}
                            </Flex>
                          </Radio.Group>
                        </Form.Item>
                      </>
                    );
                  })}
                </>
              );
            }}
          </Form.List>
        </>
      ),
    },
  ];

  return (
    <Modal
      title={
        currentData ? (
          <IntlMessage id="global.edit" />
        ) : (
          <IntlMessage id="global.add" />
        )
      }
      open={open}
      destroyOnClose={true}
      onCancel={handleCancel}
      width="80%"
      onOk={handleSubmit}
      footer={[
        <Button key="back" type="default" onClick={handleCancel}>
          {<IntlMessage id="global.cancel" />}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          loading={loading}
          onClick={handleSubmit}>
          {<IntlMessage id="global.save" />}
        </Button>,
      ]}>
      <Form
        {...layout}
        form={form}
        initialValues={initialValues}
        labelAlign="left"
        onFinish={handleSubmit}
        onFinishFailed={onFinishFailed}>
        <Tabs defaultActiveKey="1" items={tabItems}></Tabs>
      </Form>
    </Modal>
  );
}
